import React from 'react';
import { Image, ImageProps } from '@chakra-ui/react';

export const UndraggableImage = React.memo((props: ImageProps) => {
  return <Image draggable="false" userSelect="none" {...props} />;
});
